import { match } from 'ts-pattern'

import { PairActivitySnackbarAth } from './pair-activity-snackbar-ath'
import { PairActivitySnackbarBoost } from './pair-activity-snackbar-boost'
import { PairActivitySnackbarGrowth } from './pair-activity-snackbar-growth'
import { PairActivitySnackbarMigrated } from './pair-activity-snackbar-migrated'
import { PairActivitySnackbarPremium } from './pair-activity-snackbar-premium'

import type { PairActivity } from '../model'

type PairActivitySnackbarProps = {
  activity: PairActivity.Activity
  onClose?: () => void
}

export const PairActivitySnackbar: React.FC<PairActivitySnackbarProps> = ({
  activity,
  onClose,
}) => {
  return match(activity)
    .returnType<React.ReactNode>()
    .with({ type: 'growth' }, (activity) => (
      <PairActivitySnackbarGrowth activity={activity} onClose={onClose} />
    ))
    .with({ type: 'highest-ath' }, (activity) => (
      <PairActivitySnackbarAth activity={activity} onClose={onClose} />
    ))
    .with({ type: 'pool-migrated' }, (activity) => (
      <PairActivitySnackbarMigrated activity={activity} onClose={onClose} />
    ))
    .with({ type: 'boost-purchased' }, (activity) => (
      <PairActivitySnackbarBoost activity={activity} onClose={onClose} />
    ))
    .with({ type: 'premium-purchased' }, (activity) => (
      <PairActivitySnackbarPremium activity={activity} onClose={onClose} />
    ))
    .exhaustive()
}
